import WouldYouLikeTo from './would-you-like-to/index.vue'
import AgreeToTerms from './AgreeToTerms'

export default {
  WouldYouLikeTo,
  AgreeToTerms
}
